// extracted by mini-css-extract-plugin
module.exports = {"priceSurgeIcon":"price-surge-icon__priceSurgeIcon___1lXm-"};